import { Component, Inject } from '@angular/core';
import { BzgModalRef, BZG_MODAL_DATA } from 'bz-genome-angular';

@Component({
  selector: 'biz-conect-confirm-modal',
  templateUrl: './conect-confirm-modal.component.html',
  styleUrls: ['./conect-confirm-modal.component.scss']
})
export class ConectConfirmModalComponent {

  constructor(public modalComponentRef: BzgModalRef,
    @Inject(BZG_MODAL_DATA) public data: { message: string, title: string, button?: string }) { }

  close() {
    this.modalComponentRef.close();
  }
  ok() {
    this.modalComponentRef.close('ok');
  }
}
